import { render, staticRenderFns } from "./gTitle.vue?vue&type=template&id=7a39390c&scoped=true"
import script from "./gTitle.vue?vue&type=script&lang=js"
export * from "./gTitle.vue?vue&type=script&lang=js"
import style0 from "./gTitle.vue?vue&type=style&index=0&id=7a39390c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a39390c",
  null
  
)

export default component.exports